import React, { useEffect, useState } from 'react';
import './style.css';

const VelocimetroModerno = ({
  valorTotalRecebimento,
  valorTotalDivida,
  porcentagemDeGanhos,
  porcentagemDoQueFalta,
  inicioFaixa,
  fimFaixa,
  valorFaixa,
  titulo = 'Indicador de Desempenho Geral',
  labelProgressao = 'Progressão de Faixa',
  labelRestante = 'Restante para mudança de faixa',
  labelRecebido = 'Valor a receber para mudança de faixa',
  exibirStatus = true,
}) => {
  const [animatedValue, setAnimatedValue] = useState(0);
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimatedValue(porcentagemDeGanhos);
      setShowAnimation(true);
    }, 300);
    return () => clearTimeout(timer);
  }, [valorTotalRecebimento]);

  const pointerRotation = -90 + porcentagemDeGanhos * 1.8;

  const arcOffset = 314 - (314 * porcentagemDeGanhos) / 100;

  const getStars = () => {
    if (porcentagemDeGanhos > 96) return 5;
    if (porcentagemDeGanhos > 92) return 4;
    if (porcentagemDeGanhos > 88) return 3;
    if (porcentagemDeGanhos > 84) return 2;
    if (porcentagemDeGanhos >= 80) return 1;
    return 0;
  };

  const getStatus = () => {
    if (porcentagemDeGanhos > 96) return 'Meta Conquistada!';
    if (porcentagemDeGanhos > 92) return 'Quase lá!';
    if (porcentagemDeGanhos > 88) return 'Progresso Visível';
    if (porcentagemDeGanhos > 84) return 'Desempenho em Alta';
    if (porcentagemDeGanhos >= 80) return 'No Caminho Certo';
    return null;
  };

  const getMessage = () => {
    if (porcentagemDeGanhos > 96)
      return 'Meta conquistada! Parabéns pelo desempenho excepcional, você é exemplo de resultado e comprometimento!';
    if (porcentagemDeGanhos > 92)
      return 'Quase lá! A meta está ao seu alcance, mantenha o ritmo e comemore suas vitórias!';
    if (porcentagemDeGanhos > 88)
      return 'O progresso é visível! Sua performance está crescendo, siga com energia e determinação!';
    if (porcentagemDeGanhos > 84)
      return 'Desempenho em alta! Sua dedicação está gerando resultados incríveis, siga com foco total!';
    if (porcentagemDeGanhos >= 80)
      return 'Você está no caminho certo! Continue firme, sua conquista está prestes a começar!';
    return null;
  };

  const formatarMonetario = valor => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valor);
  };

  return (
    <div className="velocimetro-modern-container">
      <div className="vm-header">
        <h1 className="vm-title">
          {titulo || 'Indicador de Desempenho Geral'}
        </h1>
        <p className="vm-subtitle">Acompanhe seu progresso em tempo real</p>
        {typeof inicioFaixa === 'number' && typeof fimFaixa === 'number' && (
          <div>
            <small className="progress-range">
              Faixa atual: <b>{inicioFaixa}%</b> a <b>{fimFaixa}%</b>
              {valorFaixa && <> — <b>{valorFaixa}</b></>}
            </small>
          </div>
        )}
      </div>

      <div className="vm-content">
        <div className="speedometer-card">
          <div className="speedometer-visual">
            <svg width="280" height="200" viewBox="0 0 280 200">
              <path
                d="M 40 180 A 100 100 0 0 1 240 180"
                stroke="#e5e7eb"
                strokeWidth="20"
                fill="none"
                strokeLinecap="round"
              />

              <path
                d="M 40 180 A 100 100 0 0 1 240 180"
                stroke="url(#gradient)"
                strokeWidth="20"
                fill="none"
                strokeLinecap="round"
                strokeDasharray="314"
                strokeDashoffset={showAnimation ? arcOffset : 314}
                style={{ transition: 'stroke-dashoffset 1.5s ease-in-out' }}
              />

              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style={{ stopColor: '#ef4444' }} />
                  <stop offset="33%" style={{ stopColor: '#f59e0b' }} />
                  <stop offset="66%" style={{ stopColor: '#fbbf24' }} />
                  <stop offset="100%" style={{ stopColor: '#10b981' }} />
                </linearGradient>
              </defs>

              <g transform="translate(140, 180)">
                <circle r="8" fill="#374151" />
                <line
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="-80"
                  stroke="#374151"
                  strokeWidth="3"
                  strokeLinecap="round"
                  transform={`rotate(${showAnimation ? pointerRotation : 180})`}
                  style={{
                    transition: 'transform 1.5s ease-in-out',
                    transformOrigin: '0 0',
                  }}
                />
              </g>
            </svg>
            <div className="speed-value">{animatedValue.toFixed(2)}%</div>
            <div className="speed-label">Desempenho</div>
          </div>
        </div>

        <div className="details-section">
          <div className="progress-card">
            <div className="d-flex flex-column gap-2">
              <div className="progress-title">
                <div className="progress-icon">
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    width="20"
                    height="20"
                  >
                    <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
                  </svg>
                </div>
                <span>{labelProgressao}</span>
              </div>
              <span className="progress-percentage">
                {animatedValue.toFixed(2)}%
              </span>
            </div>
            <div className="progress-bar-wrapper">
              <div
                className="progress-bar-fill"
                style={{ width: showAnimation ? `${animatedValue}%` : '0%' }}
              ></div>
            </div>
          </div>

          <div className="metrics-row">
            <div className="metric-box danger">
              <div className="metric-header">
                <div className="metric-icon-wrapper">
                  <svg fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM10 7a1 1 0 011 1v4a1 1 0 11-2 0V8a1 1 0 011-1zm0 8a1 1 0 100-2 1 1 0 000 2z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="metric-info">
                  <div className="metric-label">
                    {labelRestante}
                  </div>
                  <div className="metric-value">
                    {porcentagemDoQueFalta.toFixed(2)}%
                  </div>
                </div>
              </div>
            </div>

            <div className="metric-box success">
              <div className="metric-header">
                <div className="metric-icon-wrapper">
                  <svg fill="currentColor" viewBox="0 0 20 20">
                    <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="metric-info">
                  <div className="metric-label">
                    {labelRecebido}
                  </div>
                  <div className="metric-value">
                    {formatarMonetario(valorTotalDivida)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {exibirStatus && porcentagemDeGanhos >= 80 && (
            <div className="status-card">
              <div className="status-content">
                <div className="status-header">
                  <h3 className="status-title">Status do Objetivo</h3>
                </div>
                <p className="status-description">{getMessage()}</p>
                <div className="achievement-stars">
                  {[1, 2, 3, 4, 5].map(star => (
                    <span
                      key={star}
                      className={`star ${star <= getStars() ? 'active' : ''}`}
                    >
                      ★
                    </span>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className='p-3'>
        <div className="next-level-container">
          <div className="next-level-row">
            <span className="fw-bold">
              <b>Próximo nível: </b>
            </span>{' '}
            <span style={{ marginLeft: '5px' }}>Faltam apenas</span>
            <span className="highlight-badge-red">
              {porcentagemDoQueFalta.toFixed(2)}%
            </span>
          </div>
          <div className="next-level-row">
            Equivalente a
            <span className="highlight-badge-green">
              {formatarMonetario(valorTotalDivida)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VelocimetroModerno;
